import templateUrl from 'emun.products/lists/product-list-email-prompt.htm';
import ServiceBus from 'servicestack/service-bus';
import basicController from 'servicestack/basic.controller.properties';
import $appConfig from "servicestack/config";
import $session from 'servicestack/session';
import shopConfig from 'emun.shopping/shopping.config';
import config from 'emun.products/lists/product-list.config';
import productListConfig from 'emun.products/lists/product-list.config';

export default class ProductListEmailPromptController {
	constructor(options) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.$session = $session;
		$ctrl.config = config;
		$ctrl.$appConfig = $appConfig;
		$ctrl.productListConfig = productListConfig;
		$ctrl.bus = new ServiceBus();
		$ctrl.title = options.title || options.heading || 'Send an email...';
		$ctrl.options = options;
		$ctrl.model = Object.assign({}, options.model);
		$ctrl.list = $ctrl.model.list;
		$ctrl.emails = [];
		$ctrl.model.from = $ctrl.$session.email;
		$ctrl.model.url = `${$ctrl.$appConfig.OrderLinkOverWrite || $appConfig.website}/ProductList?ListId=${$ctrl.list.id}`;
		$ctrl.templates = [];
		$ctrl.bus.send('GetTemplates.json').then(function (response) {
			if (response.data) {
				$ctrl.templates = response.data.filter(t => t.labels.indexOf("productlist") > -1 || t.labels.indexOf("ProductList") > -1);
			}
			if ($ctrl.templates.length === 1) $ctrl.model.templateId = $ctrl.templates[0].name;
			if ($ctrl.templates.length) $ctrl.model.message = "";
			else {
				if ($ctrl.productListConfig.productListUrl) {
					$ctrl.productListConfig.productListUrl = $ctrl.productListConfig.productListUrl.replace("ListId=", "ListId=" + $ctrl.list.id);
					$ctrl.model.message= `Browse to ${$ctrl.productListConfig.productListUrl}`;
				} else {
					$ctrl.model.message = `Browse to ${$ctrl.$appConfig.OrderLinkOverWrite || $ctrl.$appConfig.website}/#/shop/?ListId=${$ctrl.list.id}&hideLeftNav=true&initialView=list`;
				}
			}
		});
		$ctrl.bus
			.read("QueryPermissions.json", {
				GroupName: "Pricelists",
				CodeNotIn: "AllPricelists",
				orderBy: "Name"
			})
			.then(res => ($ctrl.pricelists = res.data.results));
	}

	selectContact(val) {
		const $ctrl = this;
		$ctrl.emails.push(val.email);
		$ctrl.contact = null;
	}

	findContacts(val) {
		const $ctrl = this;
		var search = encodeURIComponent(val);
		let url = `QueryRetailerContactsJoin.json?OnlyWithEmail=1&Search=${search}&OrderBy=Name`; 
		return $ctrl.bus
		  .send(url, {
			op: "ProductListEmailPrompt",
		  })
		  .then((res) =>
		  res.data.results.filter((value,index,self) => {return self.findIndex(v => v.email === value.email) === index;}).map((contact) =>
			Object.assign(contact, { })
		  )
		);
	  }

	  refreshContacts(val) {
		const $ctrl = this;
		var search = encodeURIComponent(val);
		if (search) {
			let url = `QueryRetailerContactsJoin.json?OnlyWithEmail=1&Search=${search}&OrderBy=Name`; 
			$ctrl.bus.send(url, {
				op: "ProductListEmailPrompt",
			  }).then((res) => {
				  $ctrl.contactsWithEmail = res.data.results.filter((value,index,self) => {return self.findIndex(v => v.email === value.email) === index;})
			  });
		}
	  }

	  addEmail(search) {
			let $ctrl = this;
			var contact = {
				name: "",
				email: search,
			};
			return contact;
		}

	parseEmail(item, model) {
		let $ctrl = this;
		$ctrl.model.sendTo = $ctrl.emails.join(",");
	}

	toggleRecipient(recipient, fieldName = 'sendTo') {
		let $ctrl = this;
		// let recipients = ($ctrl.model[fieldName] || '').split(/[,^;:<>!?\n\s\r]+/).filter(r => r && r.length);
		// let index = recipients.indexOf(recipient);
		// if (index >= 0) {
		// 	recipients.splice(index, 1);
		// } else {
		// 	recipients.push(recipient);
		// }
		// $ctrl.model[fieldName] = recipients.join(', ');

		let index = $ctrl.emails.indexOf(recipient);
		if (index >= 0) {
			$ctrl.emails.splice(index, 1);
		} else {
			$ctrl.emails.push(recipient);
		}
		$ctrl.model[fieldName] = recipients.join(', ');
	}

	submit() {
		const $ctrl = this;
		$ctrl.model.replyTo = $ctrl.model.from;
		$ctrl.submitting = true;
		if ($ctrl.templates.length > 0) {
			if ($ctrl.model.pricelist) {
				$ctrl.model.url = $ctrl.model.url + "&PriceListId=" + $ctrl.model.pricelist;
			}
			$ctrl.request = {
				sendTo: $ctrl.model.sendTo,
				templateId: $ctrl.model.templateId,
				globalContent: {
					"LIST_URL": $ctrl.model.url,
					"LIST_LABEL": $ctrl.list.label,
					"LIST_ID": $ctrl.list.id,
					"USER_PROFILE": $ctrl.$session.meta['ProfileImage'] ? $ctrl.$session.meta['ProfileImage'].replace(" ","%20") : "",
					"USER_NAME": $ctrl.$session.fullName,
					"MESSAGE": $ctrl.model.message,
					"EMAIL_MESSAGE": $ctrl.model.message
				}
			};
			$ctrl.bus.send('SendTemplate', $ctrl.request).then(res => {
				$ctrl.modals.alert("Your list has been shared");
				$ctrl.$close(res);
			});
		} else if ($ctrl.config.emailKlaviyo) {
			$ctrl.bus.send("CreateKlaviyoEvent", {
				email: $ctrl.model.sendTo,
				eventName: "Email Product List",
				eventData: JSON.stringify({
					listId: $ctrl.list.id,
					listLabel: $ctrl.list.label,
					url: $ctrl.model.url
			})}).then(res => {
				$ctrl.modals.alert("Your wishlist has been shared");
				$ctrl.$close(res);
			});
		} else {
			$ctrl.bus.send('SendEmail', $ctrl.model).then(res => {
				$ctrl.modals.alert("Your list has been shared");
				$ctrl.$close(res);
			});
		}
	}

};